import * as Yup from "yup";

export const stockAdjustmentSchema = Yup.object().shape({
    name: Yup.string().required(),
});